import { Link } from "react-router-dom";
import logo from "../../../../admin/images/logo.svg";

export function NavMenuToggle() {
  setTimeout(() => {
    const mainwrapper = document.querySelector("#main-wrapper");
    if (!mainwrapper) return;
    if (mainwrapper.classList.contains("menu-toggle")) {
      mainwrapper.classList.remove("menu-toggle");
    } else {
      mainwrapper.classList.add("menu-toggle");
    }
  }, 0);
}

/** Logo lives in SideBar (Qwikxy style). This only keeps toggle helper exported. */
const NavHader = () => {
  return (
    <div className="qx-nav-header-spacer" aria-hidden="true">
      <Link to="/dashboard" className="qx-mobile-logo d-lg-none">
        <img src={logo} alt="Logo" />
      </Link>
    </div>
  );
};

export default NavHader;
